import _ from 'lodash';

export default (currentVmNode, question, answers) => ({
    visible: {
        get: () =>
            _.every(question.filters, filter => {
                if (answers[filter.questionCode] !== undefined) {
                    return answers[filter.questionCode] === filter.answer;
                }
                return false;
            }),
    },
    required: {
        get: () => currentVmNode.aspects.visible && question.required,
    },
});
